<template>
  <div class="brand-list">
    <loading :active.sync="isLoading" :is-full-page="false" style="z-index: 0"></loading>
    <div class="brand-box">
      <brand-icon-slider v-for="(brand, index) in brands"
                         :key="index"
                         :title="brand.title"
                         :list="brand.brandList">
      </brand-icon-slider>
    </div>
    <div class="back" v-if="brands !== undefined">
      <v-btn class="v-btn-primary" color="primary" outlined @click="back">
        返回
      </v-btn>
    </div>
  </div>
</template>

<script>
import BrandIconSlider from '../../components/BrandIconSlider.vue'

export default {
  name: 'BrandList',
  components: {BrandIconSlider},
  props: {
    brandsList: {},
  },
  data: () => ({
    brands: {},
    isLoading: true,
  }),
  created() {
    this.brands = this.$route.params.brandsList;
    this.isLoading = false;

    // 不是從 props 送進來的，就從API取得資料
    if (this.brands === undefined) {
      this.isLoading = true;
      axios.get('/ticket/api/brand/list')
      .then((response) => {
        this.brands = response.data;
        this.isLoading = false;
      })
    }
  },
  methods: {
    back() {
      this.$router.replace({ name: 'homepage' })
    },
  },
}
</script>

<style lang="scss" scoped>
.brand-list {
  padding: 0px 4.8%;
  width: 100%;
  margin-bottom: 20px;
  background-color: #ffffff;
}

.brand-box {
  display: grid;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  grid-auto-rows: minmax(100px, auto);
  margin-top: 10px;
}

.back {
  margin-top: 20px;
}
</style>